import { render, staticRenderFns } from "./FieldDocument.vue?vue&type=template&id=500f8e99&scoped=true"
import script from "./FieldDocument.vue?vue&type=script&lang=js"
export * from "./FieldDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f8e99",
  null
  
)

export default component.exports